module.exports = __webpack_public_path__ + "img/currency.e0e560ac.png";